module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "statistics-top-nav"
  }, [_c('a', {
    class: {
      active: _vm.showStatistics === 'User'
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.userStatistics()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("statisticsView.userStatistics")))]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.showStatistics === 'Event'
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.eventStatistics()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("statisticsView.eventStatistics", [_vm.eventNumTop])))]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.showStatistics === 'TopUsers'
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.topEventParticipants()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("statisticsView.topEventParticipants", [_vm.usersNumTop])))]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.showStatistics === 'TopOrganizations'
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.topOrganizationStatistics()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("statisticsView.allStatistics", [_vm.organizationsNumTop])))])]), _vm._v(" "), (_vm.showStatistics == 'User') ? _c('div', [_c('kk-user-statistics')], 1) : _vm._e(), _vm._v(" "), (_vm.showStatistics == 'Event') ? _c('div', [_c('kk-event-statistics', {
    attrs: {
      "numTop": _vm.eventNumTop
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showStatistics == 'TopUsers') ? _c('div', [_c('kk-top-event-participants', {
    attrs: {
      "numTop": _vm.usersNumTop
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showStatistics == 'TopOrganizations') ? _c('div', [_c('kk-all-statistics', {
    attrs: {
      "numTop": _vm.organizationsNumTop
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openMoreStatistics()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("statisticsView.moreStatistics")))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08a6c3cc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/ts/views/StatisticsView.vue
// module id = 108
// module chunks = 0